export const ProfileText = {
    Certificates: {
        en: "Certificates",
        mr: "प्रमाणपत्रे",
    },
    AllPrograms: {
        en: "All programs",
        mr: "वैयक्तिक वित्त",
    },
    Logout: {
        en: "Log Out",
        mr: "लॉगआउट करा",
    },
};
